import { DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { LayoutModule, SharedModule } from '@app/shared';
import { MaterialModule } from '@app/shared/material.module';
import { ChangeStatusDialogComponent, SellerMgmtSellerProfileListComponent, SellerProfileRoutingModule } from './index';
@NgModule({
  declarations: [SellerMgmtSellerProfileListComponent, ChangeStatusDialogComponent],
  imports: [
    SellerProfileRoutingModule,
    MaterialModule,
    LayoutModule,
    SharedModule,
  ],
  entryComponents: [ChangeStatusDialogComponent],
  providers: [DatePipe]
})
export class SellerProfileModule { }
